import * as yup from 'yup';
import { RowActionsDropdown } from '../../component/common/table/action-dropdown/RowActionsDropdown';

export const getPaymentColumnDefinition = (onEdit, onView, onDelete) => [
  {
    id: 'consultantName',
    accessorKey: 'consultantName',
    header: 'Consultant',
    size: 180,
    minSize: 140,
    filterFn: 'tableFilterFn'
  },
  {
    id: 'amount',
    accessorKey: 'amount',
    header: 'Amount',
    size: 110,
    minSize: 100,
    cell: ({ row }) => `R${parseFloat(row.original.amount ?? 0).toFixed(2)}`
  },
  {
    id: 'reference',
    accessorKey: 'reference',
    header: 'Reference',
    size: 150,
    minSize: 120,
    filterFn: 'tableFilterFn',
    cell: ({ row }) => row.original.reference ?? <span style={{ color: 'var(--text-gray)' }}>-</span>
  },
  {
    id: 'periodFrom',
    accessorKey: 'periodFrom',
    header: 'Period From',
    size: 120,
    minSize: 100,
    cell: ({ row }) => row.original.periodFrom
      ? new Date(row.original.periodFrom).toLocaleDateString('en-ZA')
      : <span style={{ color: 'var(--text-gray)' }}>-</span>
  },
  {
    id: 'periodTo',
    accessorKey: 'periodTo',
    header: 'Period To',
    size: 120,
    minSize: 100,
    cell: ({ row }) => row.original.periodTo
      ? new Date(row.original.periodTo).toLocaleDateString('en-ZA')
      : <span style={{ color: 'var(--text-gray)' }}>-</span>
  },
  {
    id: 'paidAt',
    accessorKey: 'paidAt',
    header: 'Paid At',
    size: 140,
    minSize: 120,
    cell: ({ row }) => row.original.paidAt
      ? new Date(row.original.paidAt).toLocaleDateString('en-ZA')
      : <span style={{ color: 'var(--text-gray)' }}>-</span>
  },
  {
    id: 'notes',
    accessorKey: 'notes',
    header: 'Notes',
    size: 180,
    minSize: 120,
    cell: ({ row }) => {
      const n = row.original.notes;
      if (!n) return <span style={{ color: 'var(--text-gray)' }}>-</span>;
      return n.length > 50 ? n.slice(0, 50) + '…' : n;
    }
  },
  {
    id: 'actions',
    header: '',
    size: 40,
    minSize: 40,
    maxSize: 40,
    enableSorting: false,
    disableExport: true,
    cell: ({ row }) => {
      const actions = [
        onEdit && { label: 'Edit', value: 'edit', onSelect: onEdit },
        onDelete && { label: 'Delete', value: 'delete', onSelect: onDelete }
      ].filter(Boolean);
      return <RowActionsDropdown row={row} actions={actions} />;
    }
  }
];

export const PAYMENT_TABS = (consultants = []) => [
  {
    label: 'Payment Details',
    fields: [
      {
        type: 'select',
        name: 'consultantId',
        label: 'Consultant',
        required: true,
        options: consultants.map((c) => ({
          key: c.id,
          label: `${c.firstName} ${c.lastName}`,
          value: c.id,
          active: true
        })),
        validation: yup.string().required('Consultant is required')
      },
      {
        type: 'decimal',
        name: 'amount',
        label: 'Amount Paid (R)',
        required: true,
        validation: yup.number().required('Amount is required').min(0.01, 'Must be greater than 0')
      },
      {
        type: 'input',
        name: 'reference',
        label: 'Payment Reference',
        validation: yup.string().nullable().optional()
      },
      {
        type: 'date',
        name: 'paidAt',
        label: 'Payment Date',
        validation: yup.string().nullable().optional()
      },
      {
        type: 'date',
        name: 'periodFrom',
        label: 'Period From',
        validation: yup.string().nullable().optional()
      },
      {
        type: 'date',
        name: 'periodTo',
        label: 'Period To',
        validation: yup.string().nullable().optional()
      },
      {
        type: 'input',
        name: 'notes',
        label: 'Notes',
        colSpan: 2,
        validation: yup.string().nullable().optional()
      }
    ]
  }
];
